"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ERFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_69)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_69`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.56 0H34.44V24H-1.56V0Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.56 0H34.44V12H-1.56V0Z",
					fill: "#56AF35"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.56 24L34.44 12L-1.56 0V24Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.89264 16.2456C10.2505 16.2456 12.1593 14.3368 12.1593 11.9789C12.1593 9.62105 10.2505 7.71228 7.89264 7.71228C5.53475 7.71228 3.62598 9.62105 3.62598 11.9789C3.62598 14.3368 5.53475 16.2456 7.89264 16.2456ZM7.89264 17.9509C4.5944 17.9509 1.9137 15.2772 1.9137 11.9719C1.9137 8.66667 4.58738 5.99298 7.89264 5.99298C11.1979 5.99298 13.8716 8.66667 13.8716 11.9719C13.8716 15.2772 11.1909 17.9509 7.89264 17.9509Z",
					fill: "#FFC945"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.82597 11.6351C7.50422 11.6351 8.05404 11.0853 8.05404 10.407C8.05404 9.72878 7.50422 9.17896 6.82597 9.17896C6.14773 9.17896 5.5979 9.72878 5.5979 10.407C5.5979 11.0853 6.14773 11.6351 6.82597 11.6351Z",
					fill: "#FFC945"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.88914 12.3509C9.56739 12.3509 10.1172 11.801 10.1172 11.1228C10.1172 10.4445 9.56739 9.89471 8.88914 9.89471C8.2109 9.89471 7.66107 10.4445 7.66107 11.1228C7.66107 11.801 8.2109 12.3509 8.88914 12.3509Z",
					fill: "#FFC945"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.89262 10.7158C8.57087 10.7158 9.12069 10.166 9.12069 9.48771C9.12069 8.80947 8.57087 8.25964 7.89262 8.25964C7.21438 8.25964 6.66455 8.80947 6.66455 9.48771C6.66455 10.166 7.21438 10.7158 7.89262 10.7158Z",
					fill: "#FFC945"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.82597 13.3474C7.50422 13.3474 8.05404 12.7975 8.05404 12.1193C8.05404 11.4411 7.50422 10.8912 6.82597 10.8912C6.14773 10.8912 5.5979 11.4411 5.5979 12.1193C5.5979 12.7975 6.14773 13.3474 6.82597 13.3474Z",
					fill: "#FFC945"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.95933 14.0561C9.63758 14.0561 10.1874 13.5063 10.1874 12.828C10.1874 12.1498 9.63758 11.6 8.95933 11.6C8.28109 11.6 7.73126 12.1498 7.73126 12.828C7.73126 13.5063 8.28109 14.0561 8.95933 14.0561Z",
					fill: "#FFC945"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.03648 15.1228C7.71473 15.1228 8.26455 14.573 8.26455 13.8948C8.26455 13.2165 7.71473 12.6667 7.03648 12.6667C6.35824 12.6667 5.80841 13.2165 5.80841 13.8948C5.80841 14.573 6.35824 15.1228 7.03648 15.1228Z",
					fill: "#FFC945"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.67863 15.6281C9.35688 15.6281 9.9067 15.0783 9.9067 14.4C9.9067 13.7218 9.35688 13.1719 8.67863 13.1719C8.00039 13.1719 7.45056 13.7218 7.45056 14.4C7.45056 15.0783 8.00039 15.6281 8.67863 15.6281Z",
					fill: "#FFC945"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_69`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ERFlag };
